import './HeroRequirements.css'

// Medieval Computer Icon
const ComputerIcon = () => (
  <svg viewBox="0 0 24 24" width="30" height="36" style={{verticalAlign: 'middle'}}>
    <defs>
      <linearGradient id="computerFrame" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#6b7280"/>
        <stop offset="50%" stopColor="#4b5563"/>
        <stop offset="100%" stopColor="#374151"/>
      </linearGradient>
      <linearGradient id="computerScreen" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#60a5fa"/>
        <stop offset="100%" stopColor="#3b82f6"/>
      </linearGradient>
    </defs>
    {/* Monitor frame */}
    <rect x="2" y="3" width="20" height="14" rx="1" fill="url(#computerFrame)" stroke="#1f2937" strokeWidth="0.5"/>
    {/* Screen */}
    <rect x="3.5" y="4.5" width="17" height="11" rx="0.5" fill="url(#computerScreen)" opacity="0.9"/>
    {/* Screen shine */}
    <rect x="4" y="5" width="8" height="5" rx="0.3" fill="#fff" opacity="0.2"/>
    {/* Windows logo on screen */}
    <g opacity="0.8">
      <rect x="10" y="8" width="2" height="2" fill="#1e3a8a"/>
      <rect x="12.5" y="8" width="2" height="2" fill="#1e3a8a"/>
      <rect x="10" y="10.5" width="2" height="2" fill="#1e3a8a"/>
      <rect x="12.5" y="10.5" width="2" height="2" fill="#1e3a8a"/>
    </g>
    {/* Stand */}
    <rect x="10" y="17" width="4" height="2" rx="0.3" fill="url(#computerFrame)"/>
    <rect x="8" y="19" width="8" height="1.5" rx="0.5" fill="url(#computerFrame)"/>
  </svg>
)

// Medieval RAM Memory Icon
const MemoryIcon = () => (
  <svg viewBox="0 0 24 24" width="30" height="36" style={{verticalAlign: 'middle'}}>
    <defs>
      <linearGradient id="ramGreen" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#34d399"/>
        <stop offset="50%" stopColor="#10b981"/>
        <stop offset="100%" stopColor="#059669"/>
      </linearGradient>
      <linearGradient id="ramChip" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#1f2937"/>
        <stop offset="50%" stopColor="#374151"/>
        <stop offset="100%" stopColor="#1f2937"/>
      </linearGradient>
    </defs>
    {/* PCB Board */}
    <rect x="4" y="7" width="16" height="10" rx="0.5" fill="url(#ramGreen)" stroke="#047857" strokeWidth="0.5"/>
    {/* Circuit traces */}
    <g opacity="0.4" stroke="#047857" strokeWidth="0.3">
      <line x1="6" y1="9" x2="18" y2="9"/>
      <line x1="6" y1="11" x2="18" y2="11"/>
      <line x1="6" y1="13" x2="18" y2="13"/>
      <line x1="6" y1="15" x2="18" y2="15"/>
    </g>
    {/* Memory chips */}
    <rect x="7" y="8.5" width="3" height="7" rx="0.3" fill="url(#ramChip)" stroke="#000" strokeWidth="0.3"/>
    <rect x="10.5" y="8.5" width="3" height="7" rx="0.3" fill="url(#ramChip)" stroke="#000" strokeWidth="0.3"/>
    <rect x="14" y="8.5" width="3" height="7" rx="0.3" fill="url(#ramChip)" stroke="#000" strokeWidth="0.3"/>
    {/* Connector pins */}
    <g fill="#d19600">
      <rect x="5" y="17.5" width="1" height="2" rx="0.2"/>
      <rect x="7" y="17.5" width="1" height="2" rx="0.2"/>
      <rect x="9" y="17.5" width="1" height="2" rx="0.2"/>
      <rect x="11" y="17.5" width="1" height="2" rx="0.2"/>
      <rect x="13" y="17.5" width="1" height="2" rx="0.2"/>
      <rect x="15" y="17.5" width="1" height="2" rx="0.2"/>
      <rect x="17" y="17.5" width="1" height="2" rx="0.2"/>
      <rect x="18" y="17.5" width="1" height="2" rx="0.2"/>
    </g>
    {/* Notch */}
    <rect x="11" y="17" width="2" height="1.5" fill="#047857"/>
  </svg>
)

// Java Coffee Icon - White porcelain cup, rebuilt for clarity
const JavaIcon = () => (
  <svg viewBox="0 0 24 24" width="30" height="36" style={{verticalAlign: 'middle'}}>
    <defs>
      <linearGradient id="cupPorcelain" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#ffffff"/>
        <stop offset="45%" stopColor="#fafafa"/>
        <stop offset="100%" stopColor="#f1f3f5"/>
      </linearGradient>
      <linearGradient id="cupEdge" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.95"/>
        <stop offset="50%" stopColor="#eef1f4" stopOpacity="0.9"/>
        <stop offset="100%" stopColor="#ffffff" stopOpacity="0.95"/>
      </linearGradient>
      <linearGradient id="coffeeFill" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#ffffff"/>
        <stop offset="50%" stopColor="#ffffff"/>
        <stop offset="100%" stopColor="#ffffff"/>
      </linearGradient>
      <radialGradient id="coffeeHighlight" cx="40%" cy="30%" r="60%">
        <stop offset="0%" stopColor="#a25b2a" stopOpacity="0.45"/>
        <stop offset="100%" stopColor="#2b1608" stopOpacity="0"/>
      </radialGradient>
      <radialGradient id="cupShine" cx="30%" cy="25%" r="70%">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.85"/>
        <stop offset="50%" stopColor="#ffffff" stopOpacity="0.2"/>
        <stop offset="100%" stopColor="#ffffff" stopOpacity="0"/>
      </radialGradient>
      <filter id="cupShadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="0" dy="1.2" stdDeviation="0.9" floodColor="#0f172a" floodOpacity="0.16"/>
      </filter>
    </defs>

    {/* Steam - smooth Java-style waves */}
    <g fill="none" stroke="#9ca3af" strokeWidth="1.2" strokeLinecap="round" opacity="0.75">
      <path d="M8 5 Q9 3.5 8.5 2.2 Q8 1.2 8.6 0.4"/>
      <path d="M12 5.3 Q13 3.7 12.6 2.2 Q12.2 1.1 12.8 0.3"/>
      <path d="M16 5 Q17 3.5 16.5 2.1 Q16 1.1 16.6 0.4"/>
    </g>

    {/* Ground shadow */}
    <ellipse cx="12" cy="20.6" rx="7.8" ry="1.4" fill="#0f172a" opacity="0.12"/>

    {/* Saucer with depth */}
    <ellipse cx="12" cy="20" rx="8.2" ry="1.9" fill="#f8fafb" stroke="#e4e6eb" strokeWidth="0.35"/>
    <ellipse cx="12" cy="19.85" rx="6.4" ry="1.2" fill="#ffffff" opacity="0.9"/>

    {/* Cup body */}
    <path d="M6.4 8.7 L7 18 Q7.1 19.6 8.6 19.6 L15.4 19.6 Q16.9 19.6 17 18 L17.6 8.7 Z"
          fill="url(#cupPorcelain)"
          stroke="#e4e6eb"
          strokeWidth="0.6"
          filter="url(#cupShadow)"/>

    {/* Rim and inner lip */}
    <ellipse cx="12" cy="8.7" rx="5.9" ry="1.55" fill="url(#cupEdge)" stroke="#eef1f4" strokeWidth="0.35"/>
    <ellipse cx="12" cy="8.55" rx="5.6" ry="1.25" fill="url(#cupShine)" opacity="0.7"/>

    {/* Coffee surface */}
    <ellipse cx="12" cy="9.4" rx="5.05" ry="1.2" fill="#2b1608" opacity="0.45"/>
    <path d="M7.6 10 L8.1 17.2 Q8.1 18.5 9.6 18.5 L14.4 18.5 Q15.9 18.5 15.9 17.2 L16.4 10 Z"
          fill="url(#coffeeFill)"/>
    <ellipse cx="11.5" cy="10.8" rx="3.4" ry="1.2" fill="url(#coffeeHighlight)"/>

    {/* Left highlight on cup */}
    <path d="M7.1 10.2 Q7.7 11.3 8.1 13 Q8.35 14.7 8.55 17" fill="none" stroke="#ffffff" strokeWidth="1.1" strokeLinecap="round" opacity="0.42"/>

    {/* Handle - porcelain with soft shadow */}
    <path d="M17.4 11.2 Q20.3 11.2 20.8 13.5 Q21.2 15.8 17.9 17.3" fill="none" stroke="url(#cupPorcelain)" strokeWidth="2" strokeLinecap="round"/>
    <path d="M17.4 11.2 Q20.3 11.2 20.8 13.5 Q21.2 15.8 17.9 17.3" fill="none" stroke="#eef1f4" strokeWidth="0.9" strokeLinecap="round"/>
    <path d="M18.1 11.7 Q19.8 12 20.1 13.6 Q20.4 15.2 18.2 16.7" fill="none" stroke="#f7f8fb" strokeWidth="0.55" strokeLinecap="round" opacity="0.65"/>
  </svg>
)

const HeroRequirements = () => {
  return (
    <div className="hero__requirements">
      <span className="hero__req-item">
        <span className="hero__req-icon"><ComputerIcon /></span>
        Windows 7+
      </span>
      <span className="hero__req-divider">•</span>
      <span className="hero__req-item">
        <span className="hero__req-icon"><MemoryIcon /></span>
        4 GB RAM
      </span>
      <span className="hero__req-divider">•</span>
      <span className="hero__req-item">
        <span className="hero__req-icon"><JavaIcon /></span>
        <a href="https://www.oracle.com/java/technologies/downloads/#jdk20-windows" target="_blank" rel="noopener noreferrer" className="hero__req-link">
          Java JDK 20+
        </a>
      </span>
    </div>
  )
}

export default HeroRequirements
